// Internal Dependencies
import {
  NINJAS_ALL_SELECTED,
  NINJAS_SELECTED,
  PAGE_UPDATE,
  ROWS_PER_PAGE_UPDATE,
  NINJAS_SEARCH_STRING,
  } from '../actions/action-types';

export function pageNumber(state = 0, action) {
  switch (action.type) {
    case PAGE_UPDATE:
      return action.payload;
    default:
  }

  return state;
}

export function rowsPerPage(state = 10, action) {
  switch (action.type) {
    case ROWS_PER_PAGE_UPDATE:
      return action.payload;
    default:
  }
  return state;
}

export function ninjasSelected(state = [], action) {
  switch (action.type) {
    case NINJAS_SELECTED:
      return action.payload;
    default:
  }
  return state;
}

export function ninjasAllSelected(state = false, action) {
  switch (action.type) {
    case NINJAS_ALL_SELECTED:
      return action.payload;
    default:
  }
  return state;
}

export function searchStringTyped(state = '', action) {
  switch (action.type) {
    case NINJAS_SEARCH_STRING:
      return action.payload;
    default:
  }
  return state;
}




/** WEBPACK FOOTER **
 ** ./src/state/ui/update-ninjas/reducers/update-ninjas-reducer.js
 **/